module.exports = __webpack_public_path__ + "img/jiance2.ae702022.png";